import SensorStatusWidget from './SensorStatusWidget';

export * from './types';
export default SensorStatusWidget;
